import { render, staticRenderFns } from "./SettingsButton.vue?vue&type=template&id=701c8f36&scoped=true"
import script from "./SettingsButton.vue?vue&type=script&lang=ts"
export * from "./SettingsButton.vue?vue&type=script&lang=ts"
import style0 from "./SettingsButton.vue?vue&type=style&index=0&id=701c8f36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701c8f36",
  null
  
)

export default component.exports